import { Box, Link, Breadcrumbs, useTheme, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { getAnnotationToolAdminProjectsPath } from '@verantos-dev/core-annotation-tool';
import { Button } from '@verantos-dev/shared-components';

import { StepRenderer } from './components/StepRenderer';
import { WizardFooter } from './components/WizardFooter';
import { WizardSidebar } from './components/WizardSidebar';
import { useIsAgentStepActive } from './hooks/useCreateProjectWizardSteps';
import { useCreateProjectWizardScreen } from './useCreateProjectWizardScreen';

export const CreateProjectWizardScreen = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { requiredFieldsFilled, setRequiredFieldsFilled, handleCancelProjectCreation } =
    useCreateProjectWizardScreen();
  const isAgentStepActive = useIsAgentStepActive();
  return (
    <Box sx={{ p: theme.spacing(3) }}>
      <Breadcrumbs id="create-project-wizard-breadcrumbs" sx={{ fontSize: '16px' }} separator="/">
        <Link
          color="inherit"
          underline="hover"
          href="#"
          onClick={() => navigate(getAnnotationToolAdminProjectsPath())}
          data-testid="breadcrumb-manage-projects"
          sx={{ cursor: 'pointer' }}
        >
          {formatMessage({ id: 'createProjectWizard.breadcrumb.adminProjects' })}
        </Link>
        <Link
          color="inherit"
          underline="none"
          data-testid="breadcrumb-create-project"
          sx={{ fontWeight: '500' }}
        >
          {formatMessage({ id: 'createProjectWizard.breadcrumb.createProject' })}
        </Link>
      </Breadcrumbs>
      <Box id="create-project-wizard-content" sx={{ display: 'flex' }}>
        <Box sx={{ flex: 1 }}>
          <Box id="create-project-title" sx={{ py: theme.spacing(4) }}>
            <Typography variant="h4">
              {formatMessage({ id: 'createProjectWizard.title' })}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              height: 'calc(100vh - 50px)',
              pl: theme.spacing(10),
            }}
          >
            <WizardSidebar />
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ flex: 1, overflow: 'auto', p: theme.spacing(4) }}>
                <StepRenderer setRequiredFieldsFilled={setRequiredFieldsFilled} />
              </Box>
              <WizardFooter
                requiredFieldsFilled={requiredFieldsFilled}
                setRequiredFieldsFilled={setRequiredFieldsFilled}
              />
            </Box>
          </Box>
        </Box>
        {/* TODO: cleanup with cp_annotation_createproject_agent ff
            The agent step uses the width the other steps leave to this column. The card's right
            edge then sits at the outer padding (3) + this width + the scroll padding (4) =
            theme.spacing(10) + theme.spacing(3) from the screen edge, the same as the left
            indent of the stepper. The Cancel button is right-aligned, so it does not move. */}
        <Box
          id="create-project-right-sidebar"
          sx={{ width: isAgentStepActive ? theme.spacing(6) : '350px' }}
        >
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              id="cancel-create-project-button"
              variant="outlined"
              displayLabel="Cancel"
              onClickHandler={handleCancelProjectCreation}
              sx={{ fontSize: '15px', textTransform: 'none' }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
